import React, { useState } from "react";

import { textareaCls } from "@/shared/components/teams-ui";

/* A question's choices, typed one per line. The text stays as the owner types it (an empty
   line doesn't vanish under their cursor); the list it reads as goes up on every change. */
export function ListInput({ value, onChange, label, placeholder }: {
  value: string[];
  onChange: (value: string[]) => void;
  label: string;
  placeholder?: string;
}) {
  const [text, setText] = useState(() => value.join("\n"));
  const change = (typed: string) => {
    setText(typed);
    onChange(typed.split("\n").map((s) => s.trim()).filter(Boolean));
  };
  return (
    <textarea
      aria-label={label}
      value={text}
      rows={Math.min(6, Math.max(2, text.split("\n").length))}
      placeholder={placeholder}
      onChange={(e) => change(e.target.value)}
      className={textareaCls}
    />
  );
}
